"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserTypeRoutes = void 0;
var UserTypeRoutes;
(function (UserTypeRoutes) {
    UserTypeRoutes["BasePrefix"] = "user-types";
    UserTypeRoutes["ById"] = ":userTypeId";
    UserTypeRoutes["All"] = "all";
    UserTypeRoutes["List"] = "list";
})(UserTypeRoutes = exports.UserTypeRoutes || (exports.UserTypeRoutes = {}));
